module.exports = __webpack_public_path__ + "img/2.634f4757.png";